import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { faFilePdf, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BackButton from "../../Components/BackButton";
import CustomModal from "../../Components/CustomModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from "../../Components/Loader";
import UseTableControls from "../../Config/UseTableControls";
import { useGetUsersQuery, useHandleStatusMutation } from "../../Redux/Apis/User";
import { dateFormatter, getFileType, isImage, openFileInNewTab } from "../../Utils";

const RepresentativeDetails = () => {

  const { id } = useParams();

  const { data, isLoading, refetch } = useGetUsersQuery({ id });
  const [changeUserStatus, { isLoading: isUpdating }] = useHandleStatusMutation();

  if (data) {
    var { data: profileData } = data
  }

  UseTableControls();

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showVipEnableModal, setShowVipEnableModal] = useState(false);
  const [showVipDisableModal, setShowVipDisableModal] = useState(false);
  const [showVipEnableSuccessModal, setShowVipEnableSuccessModal] = useState(false);
  const [showVipDisableSuccessModal, setShowVipDisableSuccessModal] = useState(false);

  const inactiveMale = () => {
    changeUserStatus({ id: profileData?._id, payload: { active: false } }).then(() => {
      refetch()
      setShowModal(false)
      setShowModal2(true)
    })
  }

  const activeMale = () => {
    changeUserStatus({ id: profileData?._id, payload: { active: true } }).then(() => {
      refetch()
      setShowModal3(false)
      setShowModal4(true)
    })
  }

  const enableVip = () => {
    changeUserStatus({ id: profileData?._id, payload: { isVipVendor: true } }).then(() => {
      refetch()
      setShowVipEnableModal(false)
      setShowVipEnableSuccessModal(true)
    })
  }

  const disableVip = () => {
    changeUserStatus({ id: profileData?._id, payload: { isVipVendor: false } }).then(() => {
      refetch()
      setShowVipDisableModal(false)
      setShowVipDisableSuccessModal(true)
    })
  }

  useEffect(() => {
    document.title = 'The Turn At | Details';
  }, [])

  return (
    <>
      <DashboardLayout>
        <div className="dashCard mb-4">
          <div className="row mb-3">
            <div className="col-12 mb-2">
              <h2 className="mainTitle">
                <BackButton />
                Profile Details
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            {
              isLoading ? <Loader /> :
                <>
                  <div className="col-12">
                    <div className="row mb-3 justify-content-between">
                      <div className="col-lg-4  order-2 order-lg-1 mb-3">
                      </div>
                      <div className="col-lg-4 text-end order-1 order-lg-2 mb-3">
                        <div className="mb-2">
                          <button onClick={() => {
                            profileData.active ? setShowModal(true) : setShowModal3(true)
                          }} className="notButton primaryColor fw-bold text-decoration-underline">{profileData.active ? 'Blacklist User' : 'Activate User'}</button>
                          <span className={`statusBadge ${profileData.active ? 'statusBadgeActive' : 'statusBadgeInactive'}`}>{profileData.active ? 'Activated' : 'Blacklisted'}</span>
                        </div>
                        {profileData?.role === 'vendor' && (
                          <div>
                            <button
                              onClick={() => {
                                profileData?.isVipVendor ? setShowVipDisableModal(true) : setShowVipEnableModal(true)
                              }}
                              className="notButton primaryColor fw-bold text-decoration-underline">
                              {profileData?.isVipVendor ? 'Disable VIP' : 'Enable VIP'}
                            </button>
                            <span className={`statusBadge ${profileData?.isVipVendor ? 'statusBadgeActive' : 'statusBadgeInactive'}`}>
                              {profileData?.isVipVendor ? 'VIP Enabled' : 'VIP Disabled'}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="col-xl-6 col-md-6 mb-3">
                            <h4 className="secondaryLabel">Name</h4>
                            <p className="secondaryText">{profileData?.name}</p>
                          </div>
                          <div className="col-xl-6 col-md-6 mb-3">
                            <h4 className="secondaryLabel">Email Address</h4>
                            <p className="secondaryText">{profileData.email}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="col-xl-6 col-md-6 mb-3">
                            <h4 className="secondaryLabel">Profile Creation Date</h4>
                            <p className="secondaryText">{dateFormatter(profileData.createdAt)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      profileData?.details &&
                      <>
                        <div className="row mb-3">
                          <div className="col-12 mb-2">
                            <h4>
                              Vendor Details
                            </h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-8">
                            <div className="row">
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel">Years of Experience</h4>
                                <p className="secondaryText">{profileData?.details?.years_of_experience}</p>
                              </div>
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel">Phone</h4>
                                <p className="secondaryText">{profileData?.details?.phone}</p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-12 col-md-12 mb-3">
                                <h4 className="secondaryLabel">About</h4>
                                <p className="secondaryText">{profileData?.details?.about}</p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-12 col-md-12 mb-3">
                                <h4 className="secondaryLabel">Documents</h4>
                                <div className="d-flex">
                                  {
                                    profileData?.details?.documents?.map(item => (
                                      <div className="me-2 cursor-pointer" onClick={() => openFileInNewTab(item)}>
                                        {
                                          getFileType(item) == "pdf" ? <FontAwesomeIcon icon={faFilePdf} size="2xl" /> : isImage(item) ? <FontAwesomeIcon icon={faImage} size="2xl" /> : null
                                        }
                                      </div>
                                    ))
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                </>
            }
          </div>
        </div>

        <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={inactiveMale} heading='Are you sure you want to blacklist this user?' />
        <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Blacklisted' />

        <CustomModal loading={isUpdating} show={showModal3} close={() => { setShowModal3(false) }} action={activeMale} heading='Are you sure you want to activate this user?' />
        <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Activated' />
        <CustomModal loading={isUpdating} show={showVipEnableModal} close={() => { setShowVipEnableModal(false) }} action={enableVip} heading='Enable VIP tier for this vendor?' />
        <CustomModal show={showVipEnableSuccessModal} close={() => { setShowVipEnableSuccessModal(false) }} success heading='VIP Tier Enabled' />
        <CustomModal loading={isUpdating} show={showVipDisableModal} close={() => { setShowVipDisableModal(false) }} action={disableVip} heading='Disable VIP tier for this vendor?' />
        <CustomModal show={showVipDisableSuccessModal} close={() => { setShowVipDisableSuccessModal(false) }} success heading='VIP Tier Disabled' />
      </DashboardLayout >
    </>
  );
};

export default RepresentativeDetails;
